import React, { useCallback, useEffect, useState } from 'react'
import ResizablePosScreen from './resizablePosScreen'
import NewSellscreenProductList from './sellscreenProducts/newSellscreenProductList'
import NewSellscreenCheckout from './sellscreenCheckout/newSellscreenCheckout'
import { CustomModal } from '../../shared/commonComponents/customModal'
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../redux/hooks'
import { ZenLoader, ZenToast } from 'zen-core-elements'
import { ThemeConsumer } from '@rneui/themed'
import ProductDetails from './newSellscreenProductDetails'
import { useFocusEffect } from '@react-navigation/native'
import { addProductApi } from '../../redux/utils/discountUtils'
import { setBarcodeValue } from '../../redux/slices/commonSlice'
import { setRoundOffSale, updateCartProductQuantity } from '../../redux/slices/newSellscreenSlice'
import { config } from '../../shared/environment'
import { getAllCategoriesForSellscreen, getCategoryProductsForSellScreen } from '../../redux/slices/sellScreenSlice'
import { getRoundOffFromAsyncStorage } from '../../utils/asyncstorageHelper'
import { shallowEqual } from 'react-redux'
import { BackHandler } from 'react-native'

const NewSellscreen = () => {
	const { productDetailsLoader, cartProductIds, sellScreenType, cartProducts } = useAppSelector((state) => state?.NewSellscreenSlice)
	const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)
	const { barcodeValue } = useAppSelector((state) => state?.common)
	const { isWrite } = useAppSelector(getScreenPermission("SellScreenStack"), shallowEqual);

	const dispatch = useAppDispatch()
	const [detailsModal, setDetailsModal] = useState({ visible: false, productId: 0 })
	const [giftCardDetailsModal, setGiftCardDetailsModal] = useState({ visible: false, giftCardId: 0 })
	const { sellScreenProducts, sellScreenCategories } = useAppSelector(state => state?.sellScreen)

	useFocusEffect(
		useCallback(() => {
			if (barcodeValue) {
				addProductUsingBarcode()
			}
		}, [barcodeValue, cartProductIds]))

	useEffect(() => {
		fetchApisForSellScreen()
	}, [])

	useEffect(() => {
		BackHandler.addEventListener('hardwareBackPress', function () {
			if (sellScreenType !== "SELL") {
				// navigation.navigate("OrderDetails",  )
			}
			return true
		})
	}, [])

	const fetchApisForSellScreen = async () => {
		// Order Settings "Round off" is stored on this device; it sets the cart's rounded total
		getRoundOffFromAsyncStorage().then((isRoundOff) => dispatch(setRoundOffSale(isRoundOff)))
		await Promise.all([getAllCategoriesApi(), getCategoryProductsApi()])
	}



	const getCategoryProductsApi = async () => {
		let payload = {
			limit: 10,
			offset: 0,
			categoryId: "",
			searchText: "",
			locationId: locationId
		}
		if (sellScreenProducts?.value?.length) {
			return
		}
		dispatch(getCategoryProductsForSellScreen({ storeId: config?.storeId, payload })).unwrap().catch(err => {
			ZenToast({ message: err?.message, type: "error" })
		})
	}

	const getAllCategoriesApi = async () => {
		if (sellScreenCategories?.value?.length) {
			return
		}
		dispatch(getAllCategoriesForSellscreen({ storeId: config?.storeId })).unwrap().catch(err => {
			ZenToast({ message: err?.message, type: "error" })
		})
	}


	const addProductUsingBarcode = () => {
		const variantData = cartProducts?.[locationId]?.find(singleVariantData => (singleVariantData?.sku === barcodeValue || singleVariantData?.upc === barcodeValue))
		const variantId = variantData?.variantId

		const matchedVariant = cartProductIds ? cartProductIds?.[locationId]?.[Number(variantId)] : undefined
		console.log(JSON.stringify(cartProducts?.[locationId], undefined, 4));

		if (matchedVariant?.quantity) {
			dispatch(updateCartProductQuantity({ variantId: Number(variantId), quantity: matchedVariant?.quantity, locationId, isBarcode: true }))
		} else {
			addProductApi({ dispatch, locationId, productId: Number(variantData?.productId), onPressDetails, isFromBarcode: true, skuId: barcodeValue! })
		}
		dispatch(setBarcodeValue(null))
	}

	const onPressDetails = (id: number, isProduct = true) => {
		if (isProduct)
			setDetailsModal({ visible: true, productId: id })
		else
			setGiftCardDetailsModal({ visible: true, giftCardId: id })
	}
	const onClose = () => setDetailsModal({ visible: false, productId: 0 })

	return (
		<ThemeConsumer>
			{({ theme }) => (
				<>
					<ResizablePosScreen
						LeftComponent={<NewSellscreenProductList onPressDetails={onPressDetails} isWrite={isWrite} />}
						rightComponent={<NewSellscreenCheckout onPressDetails={onPressDetails} isWrite={isWrite} />}
					/>
					<CustomModal visible={(productDetailsLoader && !detailsModal.visible) ? true : false} transparent >
						<ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../assets/infinityLoader.json')} />
					</CustomModal>
					<ProductDetails isWrite={isWrite} visible={detailsModal.visible} onClose={onClose} productId={detailsModal.productId} />
				</>
			)}
		</ThemeConsumer>
	)
}

export default NewSellscreen